// tslint:disable:max-line-length

import React from 'react';

export const ChartBullet = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <rect y="15" width="16" height="1" />
      <rect x="1.5" y="5.95" width="6" height="8" opacity="0.3" />
      <rect x="3.5" y="2" width="2" height="12" />
      <rect x="8.5" y="1.5" width="6" height="12.5" opacity="0.3" />
      <rect x="10.5" y="6" width="2" height="8" />
    </svg>
  );
};
